import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApiService } from './../../services/api.service';
import { UtilService } from './../../services/util.service';
import { CommonProfileInfoComponent } from '../common-profile-info/common-profile-info.component';
import { BusinessCardComponent } from '../../components/cards/business-card/business-card.component';

@Component({
  selector: 'app-similar-business-near-you',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CommonProfileInfoComponent,
    BusinessCardComponent
  ],
  templateUrl: './similar-business-near-you.component.html',
  styleUrls: ['./similar-business-near-you.component.scss']
})
export class SimilarBusinessNearYouComponent implements OnInit, OnChanges {


  // business search based query ;

  @Input('title') title: string = 'Similar Business Near you (Public search)';
  @Input() inputData: string;
  @Input() maxMin: any = {};
  @Input() page: string;
  viewType: string = "MIN";
  headerTitle: string = 'Similar Business Near You';
  user: any = [];
  commonDatahide:any={}
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  @Input() widgetDesc: string;
  @Input() suggestion: any;

  /** Set only by the business page wireframe sidebar: the business being
   *  viewed (localStorage 'businessId' is often the viewer's own business). */
  private similarBusinessId: string;

  constructor(private util: UtilService,private a_route: ActivatedRoute, private api: ApiService,private router:Router,
    @Optional() @Inject(WIDGET_DATA) widgetData: any) {
    // Wireframe sidebar only — every other use keeps the existing behaviour.
    if (widgetData?.similarBusinessId) {
      this.similarBusinessId = widgetData.similarBusinessId;
      this.inputData = widgetData.inputData;
      this.page = widgetData.page;
      this.widgetDesc = widgetData.widgetDesc;
      if (widgetData.commonFunction) {
        this.commonFunction = widgetData.commonFunction;
      }
    }
   }
  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Similar Business Near You';
    dataPass.masterMenu =  this.inputData;
    dataPass.widgetName = "SimilarBusinessNearYouComponent";
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.a_route.queryParams.subscribe((res) => {
      if(res.master && res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
        this.headerTitle=res.menu;
      }
   });

    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
     }
     // No full-page spinner for the sidebar widget (the sidebar has its own skeleton).
     if (!this.similarBusinessId) {
       this.util.startLoader()
     }
    if (this.inputData && this.inputData != "") {
      this.api.query("business/similar/"+localStorage.getItem('userId')+"/"+(this.similarBusinessId || localStorage.getItem('businessId')))
      .subscribe((res)=>{
        this.util.stopLoader()
        if(res!=null  && res.data!=null && res.data.businessList!=null && res.data.businessList.length!==0){
          if (res['data'] && res['data'] != null && res['data'].businessList != null && res['data'].businessList.length != 0){
            this.user = res.data.businessList;
          }else{
            this.hide(true)
          }
         }else{
            this.hide(true)
         }

        },err => {
          this.util.stopLoader()
          //if(err.status==500){
            this.hide(true)
         // }

        });
   }
  }

  hide(flag){
    this.commonDatahide.widgetName="SimilarBusinessNearYouComponent";
    this.commonDatahide.hide=flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      this.commonFunction.emit(this.commonDatahide);
    }
  }
}
